export const short = 'ddd MMM D'
export const dbDate = 'YYYY-MM-DD'
